
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useIsMobile } from '../hooks/use-mobile';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { MapPin, Calendar, Ticket } from 'lucide-react';
import { Button } from "@/components/ui/button";

const Tickets = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  
  const upcomingShows = [
    { 
      id: '1', 
      title: 'Zezé Di Camargo & Luciano - Tour 2024',
      artist: 'Zezé Di Camargo & Luciano',
      city: 'São Paulo, SP',
      venue: 'Arena Sertaneja',
      date: '15/06/2024',
      price: 'R$ 150,00',
      imageSrc: '/public/zeze&luciano.jpg'
    },
    { 
      id: '2', 
      title: 'Edson & Hudson em Jaguariúna',
      artist: 'Edson & Hudson',
      city: 'Jaguariúna, SP',
      venue: 'Espaço Country',
      date: '22/06/2024',
      price: 'R$ 130,00',
      imageSrc: '/public/edson_hudson.png'
    },
    { 
      id: '3', 
      title: 'Jorge & Mateus - Tour 2024',
      artist: 'Jorge & Mateus',
      city: 'Goiânia, GO',
      venue: 'Parque de Exposições',
      date: '29/06/2024',
      price: 'R$ 120,00',
      imageSrc: '/public/Victor_e_Leo.jpg'
    },
    { 
      id: '4', 
      title: 'Maiara & Maraisa em Barretos',
      artist: 'Maiara & Maraisa',
      city: 'Barretos, SP',
      venue: 'Estádio Municipal',
      date: '05/07/2024',
      price: 'R$ 100,00',
      imageSrc: '/public/fernando_sorocaba.jpeg'
    },
  ];

  const handleBuyTicket = (show) => {
    navigate('/pagamento', { state: { ticketInfo: show, activeTab: 'tickets' } });
  };

  return (
    <div className="bg-[#141414]">
      <Header />
      <main className="pt-[70px] sm:pt-[80px] md:pt-[90px] p-3 sm:p-4 md:p-5 overflow-visible relative">
        <div className="container mx-auto">
          {!isMobile && (
            <img 
              src="/public/zeze-apontando.png" 
              alt="Zezé apontando" 
              className="fixed w-[200px] sm:w-[300px] md:w-[400px] hidden md:block left-0 top-[50%] translate-y-[50%] ml-5 z-10"
            />
          )}
          <div className={`${isMobile ? 'pl-0' : 'pl-0 md:pl-[20%] lg:pl-[25%]'} sub_main overflow-visible relative`}>
            <h1 className="text-4xl md:text-3xl sm:text-2xl text-white font-bold mb-10 text-left">Ingressos Disponíveis</h1>
            
            <section className="mb-12">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {upcomingShows.map((show) => (
                  <Card key={show.id} className="bg-black/80 border-gray-800 hover:border-rustico-brown transition-all overflow-hidden">
                    <div className="h-48 overflow-hidden">
                      <img 
                        src={show.imageSrc} 
                        alt={show.title} 
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <CardHeader>
                      <CardTitle className="text-white text-xl">{show.title}</CardTitle>
                      <CardDescription className="text-gray-400">{show.artist}</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-2 text-gray-300">
                      <div className="flex items-center gap-2">
                        <MapPin size={16} />
                        <span>{show.city} - {show.venue}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Calendar size={16} />
                        <span>{show.date}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Ticket size={16} />
                        <span>{show.price}</span>
                      </div>
                    </CardContent>
                    <CardFooter>
                      <Button 
                        variant="default" 
                        className="w-full bg-rustico-brown hover:bg-[#6f5f3f]"
                        onClick={() => handleBuyTicket(show)}
                      >
                        Comprar Ingressos
                      </Button>
                    </CardFooter>
                  </Card>
                ))}
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Tickets;
